import React, { MouseEvent, MouseEventHandler } from 'react';
import {
  ClickAwayListener,
  MenuItem,
  MenuList,
  Tooltip,
} from '@material-ui/core';
import { uniqueId } from 'lodash';

import { StyledDecisionDropDown } from 'components/SahamDropDown/styled-component';
import SahamDropDown, { SahamDropDownProps } from 'components/SahamDropDown';

export interface MenuItemProps {
  title: string;
  action: MouseEventHandler;
  disabled?: boolean;
  titleTooltip?: boolean;
}
export interface DropDownDecisionMenuProps extends SahamDropDownProps {
  menuElements: MenuItemProps[];
  width?: string;
  height?: string;
  marginMenuList?: string;
  backgroundColor?: string;
  textColor?: string;
  iconColor?: string;
}

export const DropDownDecisionMenu: React.FC<DropDownDecisionMenuProps> = (
  props,
): JSX.Element => {
  const {
    width,
    height,
    marginMenuList,
    backgroundColor,
    textColor,
    iconColor,
  } = props;
  const handleClose = (event: MouseEvent<EventTarget>) => {
    props.setDropDown(null);
  };

  return (
    <StyledDecisionDropDown
      height={height}
      width={width}
      marginMenuList={marginMenuList}
      backgroundColor={backgroundColor}
      textColor={textColor}
      iconColor={iconColor}
    >
      <SahamDropDown {...props} iconclass="drop-down-icon">
        <ClickAwayListener onClickAway={handleClose}>
          <MenuList>
            {props.menuElements.map(
              ({ title, action, disabled, titleTooltip }) =>
                titleTooltip ? (
                  <Tooltip title={titleTooltip} aria-label="add">
                    <MenuItem
                      key={uniqueId('menu-item')}
                      style={{
                        opacity: '0.5',
                      }}
                    >
                      {title}
                    </MenuItem>
                  </Tooltip>
                ) : (
                  <MenuItem
                    key={uniqueId('menu-item')}
                    onClick={e => {
                      action(e);
                      handleClose(e);
                    }}
                    disabled={disabled}
                  >
                    {title}
                  </MenuItem>
                ),
            )}
          </MenuList>
        </ClickAwayListener>
      </SahamDropDown>
    </StyledDecisionDropDown>
  );
};

export default DropDownDecisionMenu;
